export const environment = {
  baseUrl: 'https://query-api-bekoarbsma-ew.a.run.app',
  // Default fallback project (used only if no project is selected yet).
  projectId: 'AREASPJCCM01',
  authProvider: 'firebase' as 'firebase' | 'demo',
  // Firebase project used for admin login + user profile (allowed projects).
  firebase: {
    projectId: 'rutasproarte',
    appId: '1:568046413472:web:96261387dde164c79c8bc5',
    apiKey: 'AIzaSyBMLQ86gRl-wM0aOxFHTKhl-nD23CyaRzU',
    authDomain: 'rutasproarte.firebaseapp.com',
    messagingSenderId: '568046413472'
  }
};
